<div class="h-40 md:h-448px mr-2 {{ imageWidthClass }}">
  <img
    class="w-full h-full object-cover"
    [src]="image?.url"
  />
</div>
